import { LiveStatsTopics, STATS_TYPES, AGGREGATION_LEVELS } from '@ahaslides-product/frontend-toolkit'

const pollActions = {
  subscribePollUpdateAction: async ({ dispatch, rootState }, { slide }) => {
    if (!slide || !slide.id) return
    if (slide.SlideOptions && slide.SlideOptions.length > 0) {
      await dispatch('fetchStatsByKeyAction', {
        statsKeys: [
          ...slide.SlideOptions.map((option) => LiveStatsTopics.answerCountPerAnswerValueTopic(
            slide.id,
            0,
            slide.version,
            option.id,
          )),
          LiveStatsTopics.answererCountPerQuestionTopic(
            slide.id,
            0,
            slide.version,
          ),
        ],
      })
    }

    dispatch('subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ANSWER_VALUE,
      callback: (statsUpdate) => {
        const {
          activityId, version, answerValue, answerCount,
        } = statsUpdate
        const { slideActive } = rootState
        if (activityId !== slideActive.id || version !== slideActive.version) return
        const optionIndex = slideActive.SlideOptions.findIndex((option) => option.id === Number(answerValue))
        if (optionIndex !== -1) {
          const newSlideOptions = [...slideActive.SlideOptions]
          newSlideOptions[optionIndex].count = answerCount
          dispatch('updateSlideActiveAction', { SlideOptions: newSlideOptions }, { root: true })
        }
      },
    })

    dispatch('subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWERER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_QUESTION,
      // callback: (statsUpdate) => {
      //   dispatch('updateSlideActiveAction', { multipleCountAnswer: Number(statsUpdate.answererCount) }, { root: true })
      // },
    })
  },
}

export default pollActions
